// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubMenuButton-module__button___EfwYc {
    background-color: #899da7;
    color: white;
    padding: 10px 10px;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 0 0 10px 10px; /* Rounded only on the bottom edges */
    transition: background-color 0.3s ease;
    min-width: 100px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    transform-style: preserve-3d;
    transition: transform 0.3s ease;
}

    .SubMenuButton-module__button___EfwYc:hover {
        background-color: darkgray;
    }

.SubMenuButton-module__active___kOUWY {
    background-color: black;
}

/* Add disabled state styling */
.SubMenuButton-module__disabled___sPfjl {
    pointer-events: none;
    opacity: 0.5;
    cursor: default;
}

    .SubMenuButton-module__disabled___sPfjl:hover {
        background-color: #899da7; /* Maintain original color even on hover */
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/SubMenu/SubMenuButton.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,4BAA4B,EAAE,qCAAqC;IACnE,sCAAsC;IACtC,gBAAgB;IAChB,sGAAsG;IACtG,4BAA4B;IAC5B,+BAA+B;AACnC;;IAEI;QACI,0BAA0B;IAC9B;;AAEJ;IACI,uBAAuB;AAC3B;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;IACpB,YAAY;IACZ,eAAe;AACnB;;IAEI;QACI,yBAAyB,EAAE,0CAA0C;IACzE","sourcesContent":[".button {\n    background-color: #899da7;\n    color: white;\n    padding: 10px 10px;\n    text-align: center;\n    border: none;\n    cursor: pointer;\n    border-radius: 0 0 10px 10px; /* Rounded only on the bottom edges */\n    transition: background-color 0.3s ease;\n    min-width: 100px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease;\n}\n\n    .button:hover {\n        background-color: darkgray;\n    }\n\n.active {\n    background-color: black;\n}\n\n/* Add disabled state styling */\n.disabled {\n    pointer-events: none;\n    opacity: 0.5;\n    cursor: default;\n}\n\n    .disabled:hover {\n        background-color: #899da7; /* Maintain original color even on hover */\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `SubMenuButton-module__button___EfwYc`,
	"active": `SubMenuButton-module__active___kOUWY`,
	"disabled": `SubMenuButton-module__disabled___sPfjl`
};
export default ___CSS_LOADER_EXPORT___;
